import { ThemeConfig } from 'antd';

export const config: ThemeConfig = {
  token: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 14,
    borderRadius: 4,
    colorWarning: '#0b75fd',
    colorPrimary: '#0B75FD',
    colorBgLayout: '#F5F6F7',
  },
  hashed: false,
  components: {
    Table: {
      headerBg: '#ffffff',
      headerColor: '#0d2247',
      headerSortActiveBg: '#ffffff',
      bodySortBg: '#ffffff',
    },
    Timeline: {
      itemPaddingBottom: 0,
    },
  },
};
